import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import { getCentreDifference } from './utilities'
import Swiper from 'swiper'

gsap.registerPlugin(ScrollTrigger)

export const scrollingCards = (el) => {

	const pin = el.querySelector('.cards__pin')
	const cards = el.querySelectorAll('.card-feature, .card-challenge')
	const header = el.querySelector('.cards__header')
	const entries = el.querySelector('.cards__entries')
	const track = el.querySelector('.cards__entries-track')
	const trackLength = cards[0].offsetWidth * (cards.length) 

	if (!el) return
	if (window.innerWidth > 650) desktopSetup()
	if (window.innerWidth <= 650) mobileSetup()

	function desktopSetup() {

		const main = gsap.timeline({
			scrollTrigger: {
				trigger: pin,
				pin: true,
				start: 'center center',
				end: `+=${cards.length * 500}px`,
				scrub: 1
			}
		})

		const tl = gsap.timeline()

		tl.to(entries, {
			duration: 0.3,
			y: `-${ getCentreDifference(entries, el).y }px`,
			ease: 'power1.out'
		})
		
		tl.to(header, {
			scale: 0.9,
			opacity: 0, 
			filter: 'blur(6px)',
		}, '<')

		const horizontal = gsap.timeline()

		horizontal.from(track, {
			duration: 1.5,
			x: 0,
			ease: 'none'
		}, '-=0.5')

		main.add(tl)
		main.add(horizontal)

		cards.forEach(card => {
			const highlight = gsap.timeline({
				scrollTrigger: {
					trigger: card,
					containerAnimation: horizontal,
					start: 'left 60%',
					end: 'right 40%',
					defaults: {
						duration: 1, 
					},
					scrub: 1 
				}
			})
			highlight.to(card, {
				scale: 1,
				opacity: 1,
				filter: 'blur(0px)',
				ease: 'power1.out'
			})
			highlight.to(card, {
				scale: 1,
				opacity: 1,
				filter: 'blur(0px)',
				ease: 'none'
			})
			highlight.to(card, {
				scale: 0.9,
				opacity: 0.4,
				filter: 'blur(6px)',
				ease: 'power1.in'
			})
		})
	}

	function mobileSetup() {
		const swiper = new Swiper(entries, {
			speed: 750,
			spaceBetween: 18,
			slidesPerView: 1.2,
			slideClass: 'swiper-card',
			wrapperClass: 'cards__entries-track'
		})
	}
}

export const initScrollingCards = () => {
	document.querySelectorAll('.cards').forEach(el => {
		scrollingCards(el)
	})
}

export default () => {}